import configuration from "../../configuration";
import {createModel} from "@rematch/core";
import {iRootModel} from "../iRootModel";
import ODataStore from 'devextreme/data/odata/store';
import ODataFulogicsStore from "fulogics-ui-core/dist/api/odata/ODataFulogicsStore";
import {Singleton} from "fulogics-ui-core/dist/Singleton";

export const WMSBasicStocksODataEndpoint = `${configuration.API_BASE_URL}/odata/WMSBasicStocks/Store`;
export const WMSBasicStocksStore = ODataFulogicsStore({
    url: WMSBasicStocksODataEndpoint,
    key: 'id',
    keyType: 'String',
});

export const WMSProductCarriersODataEndpoint = `${configuration.API_BASE_URL}/odata/WMSStockCarriers/Store`;
export const WMSProductCarriersStore = ODataFulogicsStore({
    url: WMSProductCarriersODataEndpoint,
    key: 'id',
    keyType: 'String',
});

export type WMSBasicStocksState = {}

export const WMSBasicStocksModel = createModel<iRootModel>()({
    state: {
        //store: WMSBasicStocksStore
    } as WMSBasicStocksState,

    effects: (dispatch) => ({}),

    // @ts-ignore
    selectors: (slice, createSelector, hasProps) => ({
        /*dxStore() { // StockScreenGridItemData // filtrowania, sortowania
            return WMSBasicStocksStore;
        }*/
    }),
})

export default WMSBasicStocksModel;
